import classNames from 'styles/utils/classNames';

interface Props {
  className?: string;
}

export default function SectionDivider({ className }: Props) {
  return (
    <div
      className={classNames(
        'border-t border-color-border-input-lightmode dark:border-color-border-input-darkmode',
        className,
      )}
    />
  );
}
